/* eslint-disable no-nested-ternary */
import React, { useContext, useCallback, useState, useMemo } from 'react';
import classNames from 'classnames';
import styled from 'styled-components';
import Container from 'ls-common-client/dist/components/Container';
import LoginMenu from './LoginMenu';
import Logo from './Logo';
import NavItem from './NavItem';
import SlideMenu from './SlideMenu';
import Wrapper from './Wrapper';
import { DATA_PUSH } from '../Search/constants';
import SearchBar from '../SearchBar';
import OriginShine from '../../assets/misc/originstate-shine.svg';
import { LINKS } from '../../constants';
import { Context } from '../../context/AppContext';
import useScrollPosition from '../../hooks/useScrollPosition';
import useDataLayerPush from '../../hooks/useDataLayerPush';
import './styles.css';

const StyledContainer = styled(Container)`
  display: flex;
  gap: 0.5rem;
  margin-right: 1rem;
`;

const StyledWrapper = styled(Container)`
  display: none;
  @media (max-width: 1025px) {
    display: block;
  }
`;

const Header = ({
  showLocationInput,
  slideIn,
  showSearch,
  showIconSearch,
  stateOfOrigin,
  hideSearch,
  headerBottom,
  headerTransparent,
  onHeaderShow,
  onBannerShow,
  is404,
  profile,
}) => {
  const {
    media: { desktop, mobile },
  } = useContext(Context);
  const [showHeader, setShowHeader] = useState(false);
  const { dataLayerPush } = useDataLayerPush();

  const handleDataLayerPush = (menuName, subMenu = '') => {
    dataLayerPush({
      eventData: {
        event: 'Website Menu Selection',
        menu_name: menuName,
        submenu_name: subMenu,
        cta_position_on_page: DATA_PUSH.CTA.PAGE_HEADER,
      },
    });
  };

  const navItems = useMemo(() => {
    const firstTwoItems = [
      {
        href: LINKS.b2bLSAdvertising,
        onClick: () => {
          handleDataLayerPush('Localsearch For Business');
        },
        label: 'Localsearch For Business',
        external: true,
      },
      {
        href: LINKS.addBusiness,
        onClick: () => {
          handleDataLayerPush('Add a Business');
        },
        label: 'Add a Business',
        icon: {
          mobile: 'external-link',
          tablet: 'external-link',
        },
        external: true,
      },
    ];

    return [
      ...(desktop ? firstTwoItems : firstTwoItems.reverse()),
      {
        label: 'Resources',
        childItems: [
          {
            href: LINKS.b2bFAQs,
            onClick: () => {
              handleDataLayerPush('Resources', 'Frequently Asked Questions');
            },
            label: 'Frequently Asked Questions',
            external: true,
          },
          {
            href: LINKS.costGuides,
            onClick: () => {
              handleDataLayerPush('Resources', 'Cost Guides');
            },
            label: 'Cost Guides',
          },
          {
            href: LINKS.b2bBlog,
            onClick: () => {
              handleDataLayerPush('Resources', 'Digital Marketing Blog');
            },
            label: 'Digital Marketing Blog',
            external: true,
          },
          {
            href: LINKS.knowledgeBase,
            onClick: () => {
              handleDataLayerPush('Resources', 'Knowledge Base');
            },
            label: 'Knowledge Base',
            external: true,
          },
        ],
      },
    ];
  }, [handleDataLayerPush]);

  const callback = useCallback(() => {
    setShowHeader(slideIn && window.scrollY > 44);
  }, [slideIn]);

  useScrollPosition(null, callback);

  const backgroundOverlay = useMemo(() => {
    if (stateOfOrigin && (stateOfOrigin === 'QLD' || stateOfOrigin === 'NSW')) {
      return OriginShine;
    }
    return null;
  }, [stateOfOrigin]);

  return (
    <Wrapper
      slideIn={slideIn}
      headerBottom={headerBottom}
      onHeaderShow={onHeaderShow}
      onBannerShow={onBannerShow}
      className={classNames({
        [`Header__StateOfOrigin Header__StateOfOrigin--${stateOfOrigin}`]: stateOfOrigin,
        'Header__wrapper--backgroundOverlay': backgroundOverlay,
        'Header--headerTransparent': headerTransparent,
      })}
      style={
        backgroundOverlay
          ? {
              backgroundImage: `url(${backgroundOverlay})`,
            }
          : { display: 'flex', justifyContent: 'space-between' }
      }
    >
      <div style={{ display: 'flex' }}>
        <StyledWrapper>
          <SlideMenu />
        </StyledWrapper>
        <div className="Header__left">
          <Logo small={mobile && showHeader && !hideSearch} mobile={mobile} />
        </div>
      </div>
      <div style={{ display: 'flex' }}>
        <StyledContainer>
          {desktop && navItems.map(item => <NavItem item={item} />)}
        </StyledContainer>
        {mobile &&
          !hideSearch &&
          (showLocationInput || showSearch || showIconSearch || showHeader) && (
            <Container
              className="Header__searchIconContainer"
              width="44px"
              marginRight="8px"
              marginTop="2px"
            >
              <SearchBar id="navbarMobileSearch" type="icon" />
            </Container>
          )}
        {!mobile &&
          !hideSearch &&
          (showLocationInput || showSearch || showHeader) && (
            <Container>
              <SearchBar
                id="navbarDesktopSearch"
                type="navbar"
                style={{ width: '370px' }}
              />
            </Container>
          )}
        <LoginMenu profile={profile} is404={is404} />
      </div>
    </Wrapper>
  );
};

export default Header;
